// 1st Party
import { quote } from './elements';
import {
    findAddressUsingGoogle,
    findPropertyUsingDomino,
    isHighProfile
} from './api';
import { showLoading } from './loading';
import Cookies from 'cookies-js';
import cookieOptions from './cookie-options';
import { isValidState } from './utilities';

// Quote box redirect flow
export const quoteRedirect = async function (form, e) {
    e.preventDefault();
    await showLoading();
    Cookies.set('cms', '', cookieOptions);
    Cookies.set('quote', '', cookieOptions);
    if (quote.occupancyInput.val() === '3') {
        window.location.href = '/landlordnotsupported';
        return;
    }
    findAddressUsingGoogle(quote.property.fullAddress.val())
        .then(function (result) {
            var hasResult = false;
            if (result && result.state) {
                hasResult = true;
            } /* result */
            if (hasResult) {
                isHighProfile(quote.firstName.val(), quote.lastName.val(), quote.emailAddress.val())
                    .then(function (highProfileResult) {
                        if (highProfileResult.isHighProfile) {
                            Cookies.set(
                                'quote',
                                JSON.stringify(
                                    {
                                        propertyAddress: `${result.streetNumber} ${result.route}, ${result.state} ${result.postalCode}`
                                    }
                                ),
                                cookieOptions
                            );
                            window.location.href = '/quoting/AgentFollowup';
                            return;
                        }
                    });
                findPropertyUsingDomino(`${result.streetNumber} ${result.route}`, result.postalCode).then(function (property) {
                    if (isValidState(result.state)) {
                        quote.currentDominoPolicy.val(property.inforce);
                        quote.priorDominoPolicy.val(property.priorinforce);

                        document.getElementById("GoogleOptimizeExperimentId").value = Cookies.get('_gaexp');

                        grecaptcha.ready(function () {
                            grecaptcha.execute(googleReCaptchaSiteKey, { action: 'newquote' }).then(function (token) {

                                document.getElementById("recaptchaTokenQuote").value = token;

                                form.submit();
                            });
                        });
                    } else {
                        Cookies.set(
                            'cms',
                            JSON.stringify(
                                createCookieObj('', `${result.streetNumber} ${result.route}`, result.postalCode, '', '', '')
                            ),
                            cookieOptions
                        );                        
                        window.location.href = '/ProductNotFound';
                        return;
                    } /* state */
                }); /* findPropertyUsingDomino */
            } /* hasResult */ else {
                Cookies.set(
                    'cms',
                    JSON.stringify(
                        createCookieObj('', '', '', '', '', '')
                    ),
                    cookieOptions
                );
                window.location.href = '/address';
                return;
            } /* hasResult */
        }); /* findAddressUsingGoogle */
};

// Address redirect flow
export const addressRedirect = async function (form, e) {
    e.preventDefault();
    await showLoading();
    Cookies.set('cms', '', cookieOptions);
    findAddressUsingGoogle(quote.property.addressStreet.val()).then(function (result) {
        var hasResult = false;
        if (result && result.state) {
            hasResult = true;
        } /* result */
        if (hasResult) {
            findPropertyUsingDomino(`${result.streetNumber} ${result.route}`, result.postalCode).then(function (property) {
                if (isValidState(result.state)) {
                    quote.currentDominoPolicy.val(property.inforce);
                    quote.priorDominoPolicy.val(property.priorinforce);

                    grecaptcha.ready(function () {
                        grecaptcha.execute(googleReCaptchaSiteKey, { action: 'newquote' }).then(function (token) {

                            document.getElementById("recaptchaTokenQuote").value = token;

                            form.submit();
                        });
                    });
                } else {
                    Cookies.set(
                        'cms',
                        JSON.stringify(createCookieObj('', `${result.streetNumber} ${result.route}`, result.postalCode, '', '', '')),
                        cookieOptions
                    );
                    window.location.href = '/dominoredirect';
                    return;
                }
            }); /* findPropertyUsingDomino */
        } else {

            findAddressUsingGoogle($('#PropertyAddress_ZipCode5').val()).then(function (result) {
                if (isValidState(result.state)) {

                    grecaptcha.ready(function () {
                        grecaptcha.execute(googleReCaptchaSiteKey, { action: 'newquote' }).then(function (token) {

                            document.getElementById("recaptchaTokenQuote").value = token;

                            form.submit();
                        });
                    });

                } else {
                    Cookies.set(
                        'cms',
                        JSON.stringify(createCookieObj('', quote.property.addressStreet.val(), '', '', '', '')),
                        cookieOptions
                    );
                    window.location.href = '/dominoredirect';
                    return;
                }
            });
        } /* hasResult */
    }); /* findAddressUsingGoogle */
};

function createCookieObj(
    propertyType,
    streetAddress,
    zipCode5,
    yearBuilt,
    squareFootage,
    jwt
) {
    let dominoType;
    switch (propertyType) {
        case 'S':
            dominoType = 'H3';
            break;
        case 'C':
            dominoType = 'H6';
            break;
        default:
            dominoType = quote.policyInput.val();
    }

    let occupancyType;
    switch (quote.occupancyInput.val()) {
        case '1':
            occupancyType = 'Primary';
            break;
        case '2':
            occupancyType = 'Vacation';
            break;
        case '3':
            occupancyType = 'Tenants';
            break;
        default:
            occupancyType = 'Primary';
    }

    let address;
    if (quote.property.fullAddress.val()) {
        address = quote.property.fullAddress.val();
    } else if (streetAddress) {
        address = streetAddress;
    } else {
        address = quote.property.addressStreet.val();
    }

    return {
        address: {
            Address: address,
            Street: streetAddress ? streetAddress : quote.property.addressStreet.val(),
            City: quote.property.city.val(),
            State: quote.property.state.val(),
            ZipCode5: zipCode5 ? zipCode5 : quote.property.zipCode5.val(),
            ZipCode4: quote.property.zipCode4.val(),
            UnitNumber: quote.property.unitNumber.val()
        },
        googleTypeAheadInput: quote.googleTypeAheadInput.val(),
        occupancyType: occupancyType,
        occupancyTypeData: quote.occupancyInput.val(),
        newPurchase: quote.newPurchase.val(),
        firstName: quote.firstName.val(),
        middleName: quote.middleName.val(),
        lastName: quote.lastName.val(),
        email: quote.emailAddress.val(),
        phoneNumber: quote.phoneNumber.val(),
        mailingAddress: quote.mailing.fullAddress.val(),
        mailingUnitNumber: quote.mailing.unitNumber.val(),
        sameAddress: quote.sameAddress.val(),

        producerCode: quote.producerCodeInput.val(),
        lengthOwned: $('input[name="IsNewPurchase"]:checked').val() === 'true' ? '1' : '2',
        // PropertyType needs to be string values: S (Single Family), D (Duplex), C (Condo), M (Mobile Home), O (Other)
        propertyType: propertyType,
        yearBuilt: yearBuilt,
        squareFootage: squareFootage,
        jwt: jwt,
        gclid: quote.gclid.val(),
        msclkid: quote.msclkid.val(),
        fbclid: quote.fbclid.val(),
        gaTrackingId: quote.gaTrackingId.val(),
        source: quote.policyOriginationMediumInput.val() === '1' ? 'Web' : 'Mobile',
        dominoType: dominoType,
        program: 'H3'
    };
}